<template>
  <div class="card">
    <h5 class="card-header">Tests</h5>
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th scope="col" class="border-top-0">Name</th>
            <th scope="col" class="border-top-0">
              Scoring
              <span data-toggle="tooltip" data-placement="top" title="Set scoring method to Standard or Pass/Fail.">
                <fa icon="question-circle" />
              </span>
            </th>
            <th class="text-center border-top-0 enabled-header">
              Enabled
              <span data-toggle="tooltip" data-placement="top" title="Enables or disables the test for the organization.">
                <fa icon="question-circle" />
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr colspan="12" v-if="!items.length" class="text-muted text-center">
            <td colspan="12">
              No tests
            </td>
          </tr>
          <tr v-for="item in items" :key="item.id">
            <td>
              <span class="pt-2" :class="item.status !== 'enabled' ? 'text-muted' : ''">{{ item.displayName }}</span>
            </td>
            <td>
              <select v-model="item.scoringType" class="form-control" :disabled="loadingMessage" required @change="toggle(item)">
                <option v-for="o in organizationScoringOptions(item.code)" v-bind:key="o.code" v-bind:value="o.code">
                  {{ o.displayName }}
                </option>
              </select>
            </td>
            <td class="text-center">
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="item.id"
                  :disabled="loadingMessage"
                  :checked="item.status === 'enabled'"
                  @change="toggle(item, $event)"
                />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import $ from "jquery";

export default {
  props: {
    organizationId: String,
  },
  data() {
    return {
      loadingMessage: null,
      formWasValidated: false,
      error: null,

      items: [],
    };
  },
  computed: {
    ...mapGetters("static", ["organizationScoring"]),
  },
  created() {
    this.load();
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip({ boundary: "window" });
  },
  watch: {
    organizationId() {
      this.load();
    },
  },
  methods: {
    organizationScoringOptions(code) {
      if (code === "investigations-v2021.12.06" || code == "investigations-v2021.04.06")
        return this.organizationScoring.filter(element => element.code === "standard");

      return this.organizationScoring;
    },
    load() {
      this.loadingMessage = "Loading...";
      this.$axios
        .get(`/v1/organizations/${this.organizationId}/tests`)
        .then(res => (this.items = res.data))
        .catch(() => this.$router.push("/404"))
        .finally(() => (this.loadingMessage = null));
    },
    reset() {
      this.loadingMessage = false;
    },
    toggle(item, $event) {
      let payload = {
        displayName: item.displayName,
        scoringType: item.scoringType,
      };
      if ($event) {
        payload.status = $event.target.checked ? "enabled" : "disabled";
      } else {
        payload.status = item.status;
      }

      this.loadingMessage = "Saving...";
      this.$axios
        .put(`/v1/organizations/${this.organizationId}/tests/${item.id}`, payload)
        .then(() => {
          this.reset();
          this.load();
        })
        .catch(err => (this.error = err))
        .finally(() => (this.loadingMessage = null));
    },
  },
};
</script>

<style lang="scss" scoped>
.table-responsive {
  max-height: 600px;
  overflow-y: auto;

  table {
    margin-bottom: 0;

    thead tr:nth-child(1) th {
      background: white;
      position: sticky;
      top: 0;
      z-index: 10;
    }

    .enabled-header {
      width: 115px;
    }
  }
}

.custom-control-label {
  cursor: pointer;
}
</style>
